import { DirectionalIconProps } from "../../types/styles";

const ChevronIcon = ({
    id,
    className,
    size = 10,
    customColor,
    direction = "down",
    ...rest
}: DirectionalIconProps) => {
    const rotationTailwindClasses = {
        up: "rotate-180",
        down: "rotate-0",
        left: "rotate-90",
        right: "-rotate-90",
    };

    const color = customColor ?? "var(--neutral-600)";

    return (
        <svg
            {...rest}
            id={id ? `icon-${id}` : `icon-chevron-${direction}`}
            className={`${rotationTailwindClasses[direction]}${className ? ` ${className}` : ""}`}
            width={size}
            height={(Number(size) * 10) / 6}
            viewBox="0 0 10 6"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M1 1L5 5L9 1"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default ChevronIcon;
